export default "__VITE_ASSET__2eeb3197__"